import React, { FC } from 'react';

import { Stack, Typography, useMediaSwitch, useTablet } from 'Modules/ui3';


export const Address: FC = () => {
    const isTablet = useTablet();

    return (
        <Stack
            width={isTablet ? '208px' : 'auto'}
        >
            <Typography
                variant={useMediaSwitch('regularBody2', 'regularCaption3', 'regularCaption1')}
                color='grayscale.shade95'
                mb={2}
            >
                Адрес
            </Typography>

            <Typography
                variant={useMediaSwitch('regularHeader2', 'regularBody2', 'regularCaption1')}
                color='grayscale.shade95'
            >
                119435 Москва, ул. Большой Саввинский пер., 8, стр. 1
            </Typography>
        </Stack>
    );
};
